module.exports = __webpack_public_path__ + "assets/img/01.5883dd64.png";